module.exports = __webpack_public_path__ + "static/media/Material.001_metallicRoughness.46ace6e0.png";